import { BridgeActionEnum } from "@/types/webview";
import { postWebviewMessage } from "@/utils/api";

export const handleEnableNotifications = (): void => {
  postWebviewMessage({
    action: BridgeActionEnum.EnableNotifications,
  });
};
